import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Nav,
  NavItem,
  NavLink,
  Row
} from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import styles from '../form.module.scss';

function ListItem(props) {
  const isSelected =
    props.isSelected ||
    props.value === props.val ||
    (props.val === 0 && props.value === '');

  return (
    <NavItem
      active={isSelected}
      onClick={e => {
        props.onChange(props.val);
      }}
    >
      <NavLink className={props.linkClassName} href="#" active={isSelected}>
        {props.children}
      </NavLink>
    </NavItem>
  );
}

function Select(props) {
  const value = props.value !== '' ? parseInt(props.value, 10) : '';
  return (
    <Input
      {...props}
      type="select"
      value={value}
      onChange={e => {
        const val = e.target.value;
        props.onChange(val !== '' ? parseInt(val, 0) : val);
      }}
    >
      {props.children}
    </Input>
  );
}

class BedFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    var { minBed, maxBed, showSuggestions, asInput, tabIndex } = this.props;
    var isAnySelected = !minBed.input.value && !maxBed.input.value;
    const listItemProps = {
      ...minBed.input,
      linkClassName: `${BS.pt1} ${BS.pb1}`
    };
    return (
      <div>
        {showSuggestions && (
          <div>
            <Nav horizontal="space-between" className={BS.navSelect}>
              <ListItem
                val=""
                {...listItemProps}
                isSelected={isAnySelected}
                onChange={() => {
                  minBed.input.onChange('');
                  maxBed.input.onChange('');
                }}
              >
                Any
              </ListItem>
              <ListItem val={1} {...listItemProps}>
                1+
              </ListItem>
              <ListItem val={2} {...listItemProps}>
                2+
              </ListItem>
              <ListItem val={3} {...listItemProps}>
                3+
              </ListItem>
              <ListItem val={4} {...listItemProps}>
                4+
              </ListItem>
            </Nav>
            <div className={`${BS.mt2} ${BS.mb2} ${BS.textCenter}`}>Or</div>
          </div>
        )}
        {asInput && (
          <Row>
            <Col xs={6}>
              <InputGroup>
                <InputGroupAddon
                  tag="label"
                  htmlFor="minBed"
                  addonType="prepend"
                  className={styles.inlineInputGroupAddon}
                >
                  <FontAwesome name="bed" className={BS.inputGroupText} />
                </InputGroupAddon>
                <Input
                  {...minBed.input}
                  placeholder="No Min"
                  tabIndex={tabIndex}
                  onChange={e => {
                    const val = e.target.value;
                    minBed.input.onChange(val !== '' ? parseInt(val, 0) : val);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={6}>
              <InputGroup>
                <InputGroupAddon
                  tag="label"
                  htmlFor="maxBed"
                  addonType="prepend"
                  className={styles.inlineInputGroupAddon}
                >
                  <FontAwesome name="bed" className={BS.inputGroupText} />
                </InputGroupAddon>
                <Input
                  {...maxBed.input}
                  placeholder="No Max"
                  tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
                  onChange={e => {
                    const val = e.target.value;
                    maxBed.input.onChange(val !== '' ? parseInt(val, 0) : val);
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
        )}
        {!asInput && (
          <Row>
            <Col xs={6}>
              <InputGroup>
                <Select {...minBed.input}>
                  <option value="" disabled={minBed.input.value !== ''}>
                    From
                  </option>
                  <option value={0}>Studio</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </Select>
              </InputGroup>
            </Col>
            <Col xs={6} className={BS.colDivider}>
              <InputGroup>
                <Select {...maxBed.input}>
                  <option value="" disabled={maxBed.input.value !== ''}>
                    To
                  </option>
                  <option value={0}>Studio</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </Select>
              </InputGroup>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default BedFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/bed-filter.js